import { render, staticRenderFns } from "./MultilingualOption.vue?vue&type=template&id=724f4703&scoped=true&"
import script from "./MultilingualOption.vue?vue&type=script&lang=js&"
export * from "./MultilingualOption.vue?vue&type=script&lang=js&"
import style0 from "./MultilingualOption.vue?vue&type=style&index=0&id=724f4703&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f4703",
  null
  
)

export default component.exports